/**
 * Blog hero images are served through /api/public/blog-hero/<file>, which can
 * resize on the fly. Request a narrow variant for thumbnails/cards so listings
 * don't download the full 1200px hero.
 */
export function heroSrc(url: string, width: 400 | 800 | 1200): string {
  if (!url.includes("/api/public/blog-hero/")) return url;
  // Stored URLs are absolute to the production domain. Serve them from the
  // current origin instead so preview/staging use this deployment's resizer.
  const path = url.slice(url.indexOf("/api/public/blog-hero/"));
  return `${path}${path.includes("?") ? "&" : "?"}w=${width}`;
}